import { Add } from '@mui/icons-material';
import { AppBar, Button, Container, Toolbar, Typography } from '@mui/material';
import { LogoNegative } from '../../main-app/components/Logo';

export const Header = () => {
  return (
    <AppBar position="static">
      <Container>
        <Toolbar
          disableGutters
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <LogoNegative height={28} width={undefined} />
          <Typography
            variant="h6"
            component={'a'}
            href={'https://upominej.cz'}
            noWrap
            sx={{
              mr: 2,
              display: { xs: 'none', sm: 'flex' },
              fontWeight: 700,
              letterSpacing: '.2rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            Nová, vždy zaplacená, faktura.
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
